import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import LookLayoutHeader from "./lookLayoutHeader";
import LookLayoutMain from "./lookLayoutMain";
import LookSidebar from "../lookNavigation/lookSideBar/lookSideBar";
import {setLookPageOpened} from "../../../actions/lookFunctions";
import {ROUTES} from "../../../routes";
import MaterialSpinner from "../../ui/materialSpinner";
import {useFeaturesRoomLayoutsChecker} from "../../../actions/asyncActionFunctions";

const LookLayout = (props) => {

  const {setLookPageOpened, history, hideOverlay, visualizersLoadedLength} = props;


  // const isVisManagement = Config.isVisualizerManagement();
  //
  // useEffect(() => {
  //   if (isVisManagement && !allFeaturesWereLoaded.includes(document.kvConfig.visualizerType)) {
  //     downloadAllFeatures();
  //   }
  //   eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])

  const featuresLoaded = useFeaturesRoomLayoutsChecker();

  const popupCloseClick = () => {
    setLookPageOpened(""); // turn button inactive
    hideOverlay(() => {
      if (!window.location.hash.includes("login") && !window.location.hash.includes("look")) {   // fade out && router change after
        history.push(ROUTES.home);
      }
    });
  }

  return (
    <div className="ll">
      <div className="ll-body ll-body--with-sidebar ll-body--layouts">
        <LookLayoutHeader/>
        {!visualizersLoadedLength || !featuresLoaded
            ? <div className="ll-main"><MaterialSpinner/></div>
            : <LookLayoutMain popupCloseClick={popupCloseClick}/>
        }
      </div>
      <LookSidebar popupCloseClick={popupCloseClick}/>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {visualizersLoaded, allFeaturesWereLoaded} = store.serverState;
  return {
    visualizersLoadedLength: visualizersLoaded.length,
    allFeaturesWereLoaded,
  };
};

const mapDispatchToProps = {
  setLookPageOpened
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LookLayout)
)
